import Waveform from './Waveform';

export default Waveform;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullWidthECGPreview/Waveform/index.js